'use strict';

module Patersons {

    export class User {
        firstName: string;
        lastName: string;
        email: string;
        email2: string;
        password: string;
        password2: string;
        recaptchaResponse: string;
    }

    export class Profile {
        firstName: string;
        lastName: string;
        phoneNumber: string;
        isPhoneNumberVerified: boolean;
        email: string;
        isEmailAddressVerified: boolean;
        accountCodes: Array<string>;
    }

    export class ProfileAddress {
      addressLine1: string;
      addressLine2: string;
      addressLine3: string;
      addressLine4: string;
      postcode: string;
      country: string;

      get address(): string{
        return [this.addressLine1, this.addressLine2, this.addressLine3, this.addressLine4, this.postcode, this.country].filter(Boolean).join("\n");
      }
    }

    export class PhoneDetails {
        mobilePhoneNumber: string;
    }

    export class ForgottenPanDetails {
        email: string;
        dob: string;
    }

    export class ForgottenPasswordDetails {
        pan: string;
        email: string;
        smsCode: string;
    }

    export class CreateAccount {
        url: string;
    }

    export class TaxFileNumber {
        number: string;
    }

    export class PasswordResetDetails {
        email: string;
        code: string;
        password: string;
        password2: string;
    }

    export class SetPasswordDetails {
        password: string;
        password2: string;
    }

    export class ChangePasswordDetails {
        currentPassword: string;
        newPassword: string;
        newPassword2: string;
    }

    export class ChangeEmailDetails {
        newEmail: string;
    }

    export class SkipMobileDetails {
        skipMobileRegistration: boolean;

        constructor(){
          this.skipMobileRegistration = true;
        }
    }

    export class PhoneConfirmationDetails {
        mobilePhoneNumber: string;
        code: string;
    }


    export class EmailConfirmation {
        userId: string;
        code: string;
    }

    export class ClientAdviser {
        Firstname: string;
        Surname: string;
        Telephone: string;
        Email: string;
        Description: string;
        HeadshotSmall: string;
        HeadshotLarge: string;
        constructor(firstname: string, surname: string, telephone: string, email: string, description: string, headshotLarge: string, headshotSmall: string) {
            this.Firstname = firstname;
            this.Surname = surname;
            this.Telephone = telephone;
            this.Email = email;
            this.Description = description;
            this.HeadshotLarge = headshotLarge;
            this.HeadshotSmall = headshotSmall;
        }
    }

    export class RecaptchaVerify {
        response: string;
        remoteip: string;
    }
}
